export default {
	'monitor.operlog.title': '操作日志记录',
	'monitor.operlog.oper_id': '日志主键',
	'monitor.operlog.business_type': '业务类型',
	'monitor.operlog.method': '方法名称',
	'monitor.operlog.request_method': '请求方式',
	'monitor.operlog.operator_type': '操作类别',
	'monitor.operlog.oper_name': '操作人员',
	'monitor.operlog.dept_name': '部门名称',
	'monitor.operlog.oper_url': '请求URL',
	'monitor.operlog.oper_ip': '主机地址',
	'monitor.operlog.cost_time': '操作耗时（毫秒）',
	'monitor.operlog.oper_param': '请求参数',
	'monitor.operlog.json_result': '返回参数',
	'monitor.operlog.status': '操作状态',
	'monitor.operlog.error_msg': '错误消息',
	'monitor.operlog.oper_time': '操作时间',
	'monitor.operlog.module': '操作模块',
};
